export default __webpack_public_path__ + "static/media/provider-streak-frame.3c795a5a.svg";